import PageHeader from './services/HeaderFilter/HeaderFilter'
import React, { useState } from 'react'
import { Space, Divider, Button } from 'antd'
import { DropDown, RangeDate } from './components'

const Template = (props) => {
    const { children, headerTitle, hasFilters, useGoBack } = props;
    const [filters, setFilters] = useState({})
    const updateFilters = (newFilter) => setFilters({ ...filters, ...newFilter })
    const users = [
        {
            value: 'Jovelle',
            label: 'Jovelle',
        },
        {
            value: 'Hema',
            label: 'Hema',
        },

    ]
    const campaign = [
        {
            value: 'Intake',
            label: 'Intake',
        },
        {
            value: 'Contact',
            label: 'Contact',
        },

    ]


    return (
        <div className='template'>
            <PageHeader useGoBack={useGoBack} headerTitle={headerTitle} >
                {hasFilters && (<Space wrap>
                    <Space>
                        <DropDown data={filters} title='Campaign' name='campaign' onChange={updateFilters} options={campaign} />
                        <DropDown data={filters} title='User' onChange={updateFilters} name='user' options={users} />
                    </Space>
                    <RangeDate
                        onChange={updateFilters}
                        name="rangeDate"
                        value={filters.rangeDate}
                        title="Date" />
                    <Divider type="vertical" style={{ height: 32 }} />
                    <Button type='text' style={{ color: "var(--color-blue)" }} onClick={() => setFilters({})}>Reset filters</Button>
                </Space>)}
            </PageHeader>
            <div className='cont_warpper'>
                {children}
            </div>

        </div>
    )
}

export default Template